import React, { useState, useRef, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import IframeResizer from 'iframe-resizer-react'
import { baseUrl } from '../components/BaseUrl';
import { courseUrl } from '../components/CourseUrl';
import Pagination from '../components/Pagination';
import axios from 'axios';
import Swal from "sweetalert2";
import '../App.css';
// const ref = useRef() as React.MutableRefObject<HTMLIFrameElement>;


const ReadCourse = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const iframeRef = useRef(null)
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(1);
  const [disabled, setDisabled] = useState(false);


  const nPages = Math.ceil(data.length / postsPerPage)
  let pages = nPages.toString().substring(0, 36).concat('');
  const { id } = useParams();

  useEffect(() => {
    getCourse();
  }, []);

  const getCourse = () => {
  const token = localStorage.getItem("codefussion-login-token");
      setLoading(true);
      const userData = {
        id: id,
      };
      axios.post(`${baseUrl}get_course_by_id.php`, userData,
        { headers:
        { Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token
        }
      }).then((response) => {
        if(response.data.status === 0){
          setLoading(false);
          Swal.fire({
            title: "Error!",
            text: "An error occurred. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
            backdrop: `
            rgba(143, 70, 0, 0.3)
            url("")
            left top
            no-repeat
          `
          });
        }else{
          response.data.map((item) => {
            setData(item.course_url);
          })
          setLoading(false);
        }
      });
    };

   const showCourse = () => {
     const indexOfLastPage = currentPage * postsPerPage;
      const indexOfFirstPage = indexOfLastPage - postsPerPage;
      const currentPosts = data.slice(indexOfFirstPage, indexOfLastPage)
     return currentPosts.map((item, index) => {
       return(
      <div className='col-md-12 col-sm-12'>
      <center>
      {/*<Iframe
        src={`${courseUrl}${item}`}
        width="100%"
        height="100%"
        display="block"
        position="relative"/> */}
        <IframeResizer
            forwardRef={iframeRef}
            heightCalculationMethod="taggedElement"
            autoResize="true"
            inPageLinks
            scrolling={true}
            src={`${courseUrl}${item}`}
            style={{minWidth: '100%', overflow: "scroll", minHeight: 2800}}
          />
      </center>

       </div>
       )
     })
   }

   // const showPagination = () => {
   //   const pageNumbers = [...Array(nPages + 1).keys()].slice(1)
   //
   //       const nextPage = () => {
   //           if(currentPage !== nPages){
   //             setCurrentPage(currentPage + 1)
   //           }else if(currentPage == nPages) {
   //             alert("yeah")
   //             // setDisabled(true)
   //             console.log("yeah")
   //           }
   //       }
   //       const prevPage = () => {
   //           if(currentPage !== 1) setCurrentPage(currentPage - 1)
   //       }
   //       return (
   //           <nav>
   //               <ul className='pagination justify-content-center'>
   //                   <li className="page-item">
   //                       <a className="page-link"
   //                           onClick={prevPage}
   //                           href='#'>
   //
   //                           Previous
   //                       </a>
   //                   </li>
   //                   {pageNumbers.map(pgNumber => (
   //                       <li key={pgNumber}
   //                           className= {`page-item ${currentPage == pgNumber ? 'active' : ''} `} >
   //
   //                           <a onClick={() => setCurrentPage(pgNumber)}
   //                               className='page-link'
   //                               href='#'>
   //
   //                               {pgNumber}
   //                           </a>
   //                       </li>
   //                   ))}
   //                   <li className="page-item">
   //                       <button disabled={disabled} className="page-link"
   //                           onClick={nextPage}
   //                           href='#'>
   //                           Next
   //                       </button>
   //                   </li>
   //               </ul>
   //           </nav>
   //       )
   //   }




  return (
    <div>
    {localStorage.getItem("codefussion-login-token") === null ? window.location.replace("/login") :
    <div className='col-md-12 col-sm-12 col-lg-12'>
    {loading ?  <div style={{ margin: 'auto', width: '50%', padding: '10px' }}>
        <div className="loader-wrapper">
        <div className="loader">
        <div className="loader loader-inner"></div>
        </div>
        </div>
        </div> :
        <div>
        <div>
        <div className="p-4 mb-4" >
        <Link to="/course-catalogue"><i className="fas fa-circle-xmark float-end text-danger exit"></i></Link>
        </div>
        <p className="text-center">{`${currentPage} of ${nPages}` }</p>
        <Pagination
          nPages={pages}
          disabled={disabled}
          setDisabled={setDisabled}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
        <div className="p-3">
        {showCourse()}
        </div>
        </div>
        <Pagination
          nPages={pages}
          disabled={disabled}
          setDisabled={setDisabled}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
        </div>
       }
    </div>
    }
    </div>
  );
};

export default ReadCourse;
